import { render, staticRenderFns } from "./infochange.vue?vue&type=template&id=0ed28d84&scoped=true"
import script from "./infochange.vue?vue&type=script&lang=js"
export * from "./infochange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed28d84",
  null
  
)

export default component.exports